import { Box, Grid, Typography } from "@mui/material";

import { EmptyPanelMessage, TwoBarPanel } from "../primitives";
import { BODY, MUTED } from "../tokens";

export default function BreadthDepthPanel({ breadthDepth, onExplore }) {
  return (
    <TwoBarPanel label="Breadth vs. Depth Summary" onExplore={onExplore}>
      {breadthDepth.length > 0 ? (
        <Grid container spacing={1}>
          {breadthDepth.map((seg) => (
            <Grid item xs={4} key={seg.label}>
              <Box sx={{ textAlign: "center" }}>
                <Box
                  sx={{
                    width: 32,
                    height: 4,
                    borderRadius: 999,
                    bgcolor: seg.color,
                    mx: "auto",
                    mb: 0.75,
                  }}
                />
                <Typography
                  sx={{
                    fontSize: "3rem",
                    fontWeight: 700,
                    color: seg.color,
                    lineHeight: 1.1,
                  }}
                >
                  {seg.count}
                </Typography>
                <Typography
                  sx={{
                    mt: 0.5,
                    fontSize: 12,
                    fontWeight: 600,
                    color: BODY,
                  }}
                >
                  {seg.label}
                </Typography>
                <Typography sx={{ fontSize: 11, color: MUTED }}>
                  {seg.definition}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      ) : (
        <EmptyPanelMessage>No insights found</EmptyPanelMessage>
      )}
    </TwoBarPanel>
  );
}
